import {
    SHOW_LOADING,
    HIDE_LOADING,
} from './RequestLoading.types'

const showLoading = () => ({ type: SHOW_LOADING })
const hideLoading = () => ({ type: HIDE_LOADING })

export { showLoading, hideLoading }